module.exports = __webpack_public_path__ + "static/img/par11.bb764b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par_game/par11.png
// module id = gNjO
// module chunks = 0